export default __webpack_public_path__ + "static/media/carside.8a4b7061.jpg";